import React, { useEffect, useState } from "react";
import { useNavigate, useParams } from "react-router-dom";
import { api } from "ticketino-api-client";
import axios from "axios";

import Header from "./components/Header";

import homeImg from "../images/visitor-img_1.png";

import { ReactComponent as IconAlert } from '../images/icon/icon-alert.svg';

const Visitor_Home = () => {
    const [orderId, setOrderId] = useState();

    const [eventId, setEventId] = useState([]);
    const [ticketTypeId, setTicketTypeId] = useState(0);
    const [posId, setPosId] = useState();

    const [loaded, setLoaded] = useState(false);

    const [selectedIam, setSelectedIam] = useState("");
    const [selectedMarketPosition, setSelectedMarketPosition] = useState("");
    const [agb1, setAgb1] = useState(false);
    const [agb2, setAgb2] = useState(false);
    const [errorMsg, setErrorMsg] = useState("");

    // react hook for navigation
    let navigate = useNavigate();

    // base url
    let baseUrl = process.env.REACT_APP_BASEURL_API;

    // setting the base url of the npm package api calls
    api.defaults.baseURL = baseUrl;

    // fetching resources
    const [resources, setResources] = useState({});

    // fetching params
    const { language } = useParams();

    let languageId = 0;

    // changing languageId according to the url
    switch (language) {
        case ("de" || "DE"):
            languageId = 1;
            break;
        case ("fr" || "FR"):
            languageId = 2;
            break;
        default:
            languageId = 0;
            language = "de";
            break;
    }

    useEffect(() => {
        // Remove addressBody from localStorage on first page load
        localStorage.removeItem("addressBody");
        loadToken();

        // clear the addedPromocodes in the session
        let array = [];
        sessionStorage.setItem("AddedPromotions", JSON.stringify(array));
    }, []); //only on first page load

    useEffect(() => {
        requestResources();

        // so it wont get called on first load
        if (loaded) {
            startOrder(posId, eventId);
        }
    }, [language]); //everytime language is changed

    const loadToken = async () => {
        await axios.get("form/token").then((res) => {
            axios.defaults.headers.common["Authorization"] = "Bearer " + res.data;
            api.defaults.headers.common['Authorization'] = "Bearer " + res.data;

            sessionStorage.setItem("token", res.data);

            requestFormSettings();
        });
    };

    const requestFormSettings = async () => {
        await axios.get(`form/formsettings`).then((res) => {
            // setting the posID and eventID
            setPosId(res.data.posId);
            setEventId(res.data.eventId);
            setTicketTypeId(res.data.ticketTypeVisitorId);

            startOrder(res.data.posId, res.data.eventId);
        });
    };

    const requestResources = async () => {
        await axios
            .get(`form/resources/${language}`)
            .then((res) => {
                setResources(res.data?.translation);
            })
            .catch((error) => console.error(error.response.data));
    };

    const startOrder = async (posId, eventId) => {
        let order = {
            affiliateShopId: null,
            currency: "CHF",
            tenantId: 1,
            languageId: languageId,
            pointOfSaleId: posId,
            abbreviation: "",
            paymentType: 1,
        };

        await axios
            .post(`${baseUrl}/ShopBasket/Order`, order)
            .then((res) => {
                sessionStorage.setItem("orderId", res.data.id);
                setOrderId(res.data.id);
                setLoaded(true);
            })
            .catch((error) => console.error(error.response.data));
    };

    const onSubmit = async () => {
        setErrorMsg("");
        try {
            await addTicketToBasket();
            await addAddressToBasket();
        } catch (error) {
            // Optionally set a generic error message
            setErrorMsg(resources?.VisitorHomeGenericError || "An error occurred. Please try again.");
        }
    };

    const addTicketToBasket = async () => {
        let addTicketTypes = [];

        addTicketTypes = [{ ticketTypeId: ticketTypeId, quantity: 1 }];

        return axios
            .post(`${baseUrl}/ShopBasket/Order/${orderId}/Tickets`, {
                ticketsToAdd: addTicketTypes,
            })
            .then(() => {
                //// gtm - addToCart
                //window.dataLayer = window.dataLayer || [];
                //window.dataLayer.push({
                //    'event': 'addToCart'
                //});
            })
            .catch((error) => {
                console.error(error.response?.data || error);
                throw error;
            });
    };

    const addAddressToBasket = async () => {
        let addressBody = {
            code1: selectedIam,
            code2: selectedMarketPosition,
        };

        // Store addressBody in localStorage for later use
        localStorage.setItem("addressBody", JSON.stringify(addressBody));
        // Navigate to the next step
        navigate(`/${language}/visitor/interests`);
    };

    // Computed variable for Next button disabled state
    const isPrivateInvestor = selectedIam === resources?.VisitorHomeIamValue2;
    const isNextDisabled =
        selectedIam === "" ||
        selectedMarketPosition === "" ||
        !agb2 ||
        (isPrivateInvestor && !agb1);

    return (
        <div className="page-container">
            <Header language={language} />
            <div className="container wrapper-small">

                <div className="row mt-2">
                    <div className="col-md-12">
                        <span className="text-title d-block">{resources?.EventName}</span>
                        <span className="text-subtitle d-block">{resources?.VisitorHomeTitle}</span>
                    </div>
                </div>

                <div className="row mt-4">
                    <div className="col-md-12">
                        <span>{resources?.VisitorHomeDesc}</span>
                    </div>
                </div>

                <div className="row mt-4">
                    <div className="col-md-8">
                        <span>{resources?._Iam}</span>

                        {/* I am - radiobutton group */}
                        <div className="mt-4">

                            {/* Professional */}
                            <label className="d-flex align-items-center" style={{ cursor: "pointer" }}>
                                <input
                                    type="radio"
                                    name="iam"
                                    value={resources?.VisitorHomeIamValue1}
                                    checked={selectedIam === resources?.VisitorHomeIamValue1}
                                    onChange={() => setSelectedIam(resources?.VisitorHomeIamValue1)}
                                    className="d-none"
                                />
                                <i className={`bi bi${selectedIam === resources?.VisitorHomeIamValue1 ? "-check" : ""}-circle me-2`}></i>
                                <span>{resources?.VisitorHomeIamValue1} <br /> {resources?.VisitorHomeIamValueDesc1}</span>
                            </label>

                            {/* Private */}
                            <label className="d-flex align-items-center mt-4" style={{ cursor: "pointer" }}>
                                <input
                                    type="radio"
                                    name="iam"
                                    value={resources?.VisitorHomeIamValue2}
                                    checked={selectedIam === resources?.VisitorHomeIamValue2}
                                    onChange={() => setSelectedIam(resources?.VisitorHomeIamValue2)}
                                    className="d-none"
                                />
                                <i className={`bi bi${selectedIam === resources?.VisitorHomeIamValue2 ? "-check" : ""}-circle me-2`}></i>
                                <span>{resources?.VisitorHomeIamValue2} <br /> {resources?.VisitorHomeIamValueDesc2}</span>
                            </label>
                        </div>
                    </div>

                    <div className="col-md-4 mt-2 mt-4 mt-md-2">
                        <img className="img-fluid" src={homeImg} alt="home" />
                    </div>
                </div>
            </div>

            {/* fullwidth background container */}
            <div className="mt-4 fullwidth-bg-container">
                <div className="container wrapper-small">
                    {resources?.VisitorHomeMarketPosition}

                    {/* Marktposition - radiobutton group */}
                    <div className="row">

                        {/* Buy-Side */}
                        <div className="col-md-6 mt-4">
                            <label className="d-flex align-items-center" style={{ cursor: "pointer" }}>
                                <input
                                    type="radio"
                                    name="marketPosition"
                                    value={resources?.VisitorHomeMarketPositionValue1}
                                    checked={selectedMarketPosition === resources?.VisitorHomeMarketPositionValue1}
                                    onChange={() => setSelectedMarketPosition(resources?.VisitorHomeMarketPositionValue1)}
                                    className="d-none"
                                />
                                <i className={`bi bi${selectedMarketPosition === resources?.VisitorHomeMarketPositionValue1 ? "-check" : ""}-circle me-2`}></i>
                                <span>{resources?.VisitorHomeMarketPositionValue1}</span>
                            </label>
                            <div className="d-flex align-items-center text-secondary" style={{ marginLeft: '1.6em' }}>
                                <span>{resources?.VisitorHomeMarketPositionValueDesc1}</span>
                            </div>
                        </div>

                        {/* Sell-Side */}
                        <div className="col-md-6 mt-4">
                            <label className="d-flex align-items-center" style={{ cursor: "pointer" }}>
                                <input
                                    type="radio"
                                    name="marketPosition"
                                    value={resources?.VisitorHomeMarketPositionValue2}
                                    checked={selectedMarketPosition === resources?.VisitorHomeMarketPositionValue2}
                                    onChange={() => setSelectedMarketPosition(resources?.VisitorHomeMarketPositionValue2)}
                                    className="d-none"
                                />
                                <i className={`bi bi${selectedMarketPosition === resources?.VisitorHomeMarketPositionValue2 ? "-check" : ""}-circle me-2`}></i>
                                <span>{resources?.VisitorHomeMarketPositionValue2}</span>
                            </label>
                            <div className="d-flex align-items-center text-secondary" style={{ marginLeft: '1.6em' }}>
                                <span>{resources?.VisitorHomeMarketPositionValueDesc2}</span>
                            </div>
                        </div>
                    </div>
                </div>
            </div>

            {/* Terms and conditions checkboxes */}
            <div className="container wrapper-small">
                <div className="row mt-5">

                    <div className="col-md-12 mb-3">
                        {/* Terms and conditions 1 - only show for private investor */}
                        {isPrivateInvestor && (
                            <label className="d-flex align-items-center mb-3" style={{ cursor: "pointer" }}>
                                <input
                                    className="d-none"
                                    type="checkbox"
                                    checked={!!agb1}
                                    onChange={() => setAgb1(!agb1)}
                                />
                                <i className={`bi bi${agb1 ? "-check" : ""}-square me-2`}></i>
                                <span dangerouslySetInnerHTML={{ __html: resources?.VisitorHomeAgb1 } }></span>
                            </label>
                        )}
                        {/* Terms and conditions 2 */}
                        <label className="d-flex align-items-center mb-3" style={{ cursor: "pointer" }}>
                            <input
                                className="d-none"
                                type="checkbox"
                                checked={!!agb2}
                                onChange={() => setAgb2(!agb2)}
                            />
                            <i className={`bi bi${agb2 ? "-check" : ""}-square me-2`}></i>
                            <span>{resources?.VisitorHomeAgb2}</span>
                        </label>
                    </div>
                    {errorMsg && (
                        <div className="alert error mt-4" role="alert" style={{ display: 'flex', alignItems: 'center' }}>
                            <IconAlert style={{ fill: 'white', marginRight: '8px', flexShrink: 0 }} />
                            <span>{errorMsg}</span>
                        </div>
                    )}
                    <div className="col-md-12 text-end">
                        <button className="btn button-custom" onClick={() => onSubmit()} disabled={isNextDisabled}>{resources?.Next}</button>
                    </div>
                </div>

                <p className="mt-4">
                    <small style={{ color: 'grey', fontSize: '10px' }}>powered by <a style={{ color: 'grey', textDecoration: 'none' }} href="https://organizer.ticketino.com/de" target="_blank">TICKETINO</a></small>
                </p>
            </div>
        </div>
    )
}

export default Visitor_Home